import Styles from './index.module.scss';
interface Props {
	iconBackground: string;
	icon: React.ReactNode;
	message: string;
}

export const ConfirmDeleteMessage = (props: Props) => {
	return (
		<div className={Styles.container}>
			<div className={Styles.avatar} style={{ backgroundColor: props.iconBackground }}>
				{props.icon}
			</div>
			<div className={Styles.messageContainer}>
				<p>{props.message}</p>
			</div>
		</div>
	);
};
